import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { spacing } from '../../config';
import { UploadedImageThumbnail } from './UploadedImageThumbnail';
import { FileCategories, getFileType } from '../../utils/getFileType';

const listWrapperStyle = css({
  marginTop: spacing.size4,
  display: 'flex',
});

const UploadedImageThumbnailList = ({
  uploadImageKeys,
  imageClickHandler,
  imageDeleteClickHandler = () => {},
  isEditable = true,
}) => (
  <div css={listWrapperStyle}>
    {uploadImageKeys.map((imageId) => (
      <UploadedImageThumbnail
        key={imageId}
        imageId={imageId}
        isEditable={isEditable}
        fileCategory={getFileType(imageId).category}
        imageClickHandler={() => imageClickHandler(imageId)}
        imageDeleteClickHandler={() => imageDeleteClickHandler(imageId)}
      />
    ))}
  </div>
);

UploadedImageThumbnailList.propTypes = {
  uploadImageKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  imageClickHandler: PropTypes.func.isRequired,
  imageDeleteClickHandler: PropTypes.func,
  fileCategory: PropTypes.oneOf(Object.values(FileCategories)),
  isEditable: PropTypes.bool,
};

export { UploadedImageThumbnailList };
